import { createLocaleMap, locale, LocaleMetadata } from "../util/LocaleUtils";
import { isFiveKeysTheme } from "../util/ThemeUtils";
import localisationData from "../data/localisation-data.json";

const generateLocaleItem: (data: {
	locale: string;
	name: string;
	technical?: boolean;
	dir?: "ltr" | "rtl";
	fullSupport?: boolean;
}) => LocaleMetadata = (data) => {
	const isFiveKeys = isFiveKeysTheme();
	const rootFileName = isFiveKeys ? "five-keys-locale" : "locale";
	if (data.locale === "en" || data.locale === "en-gb") {
		return locale(
			data.locale,
			data.name,
			() =>
				data.locale === "en-gb"
					? // eslint-disable-next-line import/no-dynamic-require
					  require(`./${rootFileName}.en-gb.json`)
					: // eslint-disable-next-line import/no-dynamic-require
					  require(`./${rootFileName}.en.json`),
			{
				technical: data.technical,
				dir: data.dir,
				fullSupport: data.fullSupport,
			},
		);
	}

	return locale(
		data.locale,
		data.name,
		() =>
			import(
				/* webpackChunkName: "[request]" */ `./${rootFileName}.${data.locale}.json`
			),
		{
			technical: data.technical,
			dir: data.dir,
			fullSupport: data.fullSupport,
		},
	);
};

const locales = createLocaleMap(
	Object.values(localisationData.locales).map((v) =>
		generateLocaleItem(v as any),
	),
);

export default locales;
